import React, {Component} from 'react';
import LayoutMain from '../../components/LayoutMain/LayoutMain';

export default class EmptyPage extends Component {
  render() {
    return (
        <LayoutMain>
            <div className="start-page">

            </div>
        </LayoutMain>
    );
  }
}
